import { render, staticRenderFns } from "./UnpublishModal.vue?vue&type=template&id=2af2a623&scoped=true"
import script from "./UnpublishModal.vue?vue&type=script&lang=js"
export * from "./UnpublishModal.vue?vue&type=script&lang=js"
import style0 from "./UnpublishModal.vue?vue&type=style&index=0&id=2af2a623&prod&lang=scss&scoped=true"
import style1 from "./UnpublishModal.vue?vue&type=style&index=1&id=2af2a623&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af2a623",
  null
  
)

export default component.exports